import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GenericFormService } from '../service/generic-form.service';
import { FieldModel } from '../model/field.model';
import { Subject } from 'rxjs';

@Component({
	selector: 'cv-checkbox-field',
	templateUrl: './checkbox-field.component.html',
	styleUrls: ['./checkbox-field.component.scss'],
})
export class CheckboxFieldComponent implements OnInit {
	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: FieldModel;
	@Input() value: any;
	options: any;
	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor(
		private formService: GenericFormService
	) { }

	ngOnInit(): void {
		this.options = this.field.options;
	}

	/**
	 * Trigger the field onChange
	 *
	 * @param $event
	 * @param field
	 * @param row
	 */
	onChange($event: any): void {
		if ('UIEvents' in this.field && this.field.UIEvents.onChange) {
			this.formService.onChangeOptions$.next({
				field: this.field,
				event: $event
			});
		}
	}

	/**
	 * Trigger the field onSelect
	 *
	 * @param $event
	 * @param field
	 * @param row
	 */
	onSelect($event: any): void {
		if (this.field.UIEvents?.onSelect) {
			this.formService.onSelectOptions$.next({
				field: this.field,
				event: $event
			});
		}
	}

	/**
	 * Trigger the field onSelect
	 *
	 * @param $event
	 * @param field
	 * @param row
	 */
	filterOptions($event: any): void {
		this.formService.onSelectOptions$.next({
			field: this.field,
			event: {}
		});
	}
}
